import loadable from 'components/dynamic-import';
import { FormInputSkeleton } from 'components/component-skeletons';

export const ColorPicker = loadable(() => import('./ColorPickerField'), true, <FormInputSkeleton />);
export const ColorPickerSimplified = loadable(() => import('./ColorPickerSimplified'), true, <FormInputSkeleton />);
export const CountryPicker = loadable(() => import('./CountryPicker'), true, <FormInputSkeleton />);
export const CurrencyPicker = loadable(() => import('./CurrencyPicker'), true, <FormInputSkeleton />);
